/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import type {BrowserOptions} from '@sentry/react'

export type SentryErrorEvent = Parameters<NonNullable<BrowserOptions['beforeSend']>>[0]

const CUSTOMER_SCRIPT = /\/account_\d+\/attachments\//

export function tagCustomerScriptEvent(event: SentryErrorEvent): SentryErrorEvent {
  const frames = event.exception?.values?.flatMap(value => value.stacktrace?.frames ?? []) ?? []
  if (frames.some(frame => CUSTOMER_SCRIPT.test(frame.filename ?? ''))) {
    event.tags = {...event.tags, customer_js: 'true'}
  }
  return event
}
